<template>
    <div class="inline d-md-down-none" style="width: 500px">
        <!--<b-button @click="showModal" variant="primary">		<i class="fa fa-search" />		</b-button>-->

        <b-input-group>
            <b-input
                type="search"
                size="md"
                :placeholder="$t('text.userSearchPlaceHolder')"
                v-model="searchString"
                @keyup.enter.native="showModal"
            />
            <b-input-group-append>
                <b-button variant="primary" @click="showModal()">
                    <i class="fa fa-search" />
                </b-button>
            </b-input-group-append>
        </b-input-group>

        <b-modal
            hide-header
            hide-footer
            :visible="modalVisible"
            ref="searchModal"
            size="lg"
            @shown="setInputFocus"
        >
            <b-input-group>
                <b-input-group-prepend>
                    <b-button disabled>
                        <i
                            v-if="result.users.loading"
                            class="fa fa-spin fa-spinner"
                        ></i>
                        <i
                            v-if="!result.users.loading"
                            class="fa fa-search"
                        ></i>
                    </b-button>
                </b-input-group-prepend>
                <b-input
                    placeholder="Search"
                    ref="focusThis"
                    v-model="searchString"
                />
            </b-input-group>

            <hr />

            <b-list-group>
                <!-- Users -->
                <b-list-group-item
                    action
                    @click="gotoUser(user)"
                    v-for="user in result.users.models"
                    class="d-flex justify-content-between align-items-center"
                    :key="user.id"
                >
                    <span>
                        <i class="fa fa-user" />
                        {{ user.name }}
                    </span>
                    <b-badge variant="primary" pill>{{ user.email }}</b-badge>
                </b-list-group-item>
            </b-list-group>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'SearchInput',

    data() {
        return {
            searchString: '',
            resultLoading: false,
            modalVisible: false,
            result: {
                users: this.$resource('users/search'),
            },
        }
    },
    created() {
        this.searchString = ''

        // AttachEventListener to window
    },

    watch: {
        searchString(newString, oldString) {
            // Return if string is equal
            if (oldString == newString) {
                return
            }

            if (this.result.users.loading) {
                // console.log('Search in progress - abort')
                //return
            }

            // If all checks passes we trigger our search
            this.triggerSearch()
        },
    },
    methods: {
        handleKeyDownEvent(e) {
            // If ctrl and space are pressed simultaneusly we toggle search
            if (e.ctrlKey && e.keyCode == 32) {
                this.showModal()
            }
        },

        showModal() {
            // console.log('showModal')
            this.modalVisible = true
            let ref = this.$refs.searchModal

            if (typeof ref != 'undefined') {
                ref.show()
            }
            return true
        },

        hideModal() {
            //// console.log("hideModal");
            this.modalVisible = false
            let ref = this.$refs.searchModal

            if (typeof ref != 'undefined') {
                ref.hide()
            }
        },

        triggerSearch() {
            this.result.users.fetch({
                params: {
                    query: this.searchString,
                    perPage: 20,
                    max: 20,
                },
            })
        },

        gotoUser(user) {
            this.$router.push(this.getUserLink(user))
            this.modalVisible = false
        },

        getUserLink(user) {
            return '/organization/' + user.company_id + '/users/' + user.id
        },

        setInputFocus() {
            let ref = this.$refs.focusThis
            ref.focus()
        },
    },
}
</script>
